module.exports = __webpack_public_path__ + "images/77b6b77.jpg";